import { TTrackEventData } from '../../tracking/constant';

export const LANGUAGE_TRACKING_EVENTS = {
  LANGUAGE_UPDATE: {
    component_name: 'select a language',
    component_type: 'dialog',
    action: 'language update',
    event: 'dialog_languageUpdate',
  },
};

export const NAVIGATION_TRACKING_EVENTS = {
  PARTNERHUB_CLICK: {
    component_name: 'partner hub link',
    event: 'partnerHub_click',
    event_type: 'Couriers',
  },
  NOTIFICATION_ICON_CLICK: {
    component_name: 'courier app portal notifications',
    event: 'list_open',
    component_type: 'list',
    list_action: 'open'
  },
  NOTIFICATION_ICON_CLICK_CLOSE: {
    component_name: 'courier app portal notifications',
    event: 'list_close',
    component_type: 'list',
    list_action: 'close'
  }
};

export const NOTIFICATION_TRACKING_EVENTS = {
  NOTIFICATION_LIST_ON_VIEW: {
    component_name: 'courier app portal notifications',
    component_type: 'list',
    list_action: 'view',
    list_countsTotal: '',
    event:'list_view'
  },
  NOTIFICATION_LIST_ON_ENGAGE: {
    component_name: 'courier app portal notifications',
    component_type: 'list',
    list_action: 'load more',
    event: 'list_engagement'
  },
  NOTIFICATION_ON_CLOSE: {
    component_name: 'courier app portal notifications',
    component_type: 'notifications',
    notification_action: 'close',
    notification_detail: '',
    event: 'notification_close'
  }
}


export const BANNER_COMMON_EVENTS = {
  BANNER_VIEW: {
      component_name: '',
      component_type: 'banner',
      event: 'banner_view',
      banner_action: 'banner view'
  },
  BANNER_SELECT: {
      component_name: '',
      component_type: 'banner',
      event: 'banner_select',
      banner_action: 'banner select',
  },
  BANNER_DISMISS: {
      component_name: '',
      component_type: 'banner',
      event: 'banner_dismiss',
      banner_action: 'banner dismiss'
  },
  BANNER_ERROR : {
      component_name: '',
      component_type: 'banner',
      event: 'banner_error',
      banner_action: 'banner error',
      banner_errorType: ''
  },
};

export const PWA_EVENTS = {
  PWA_ACTIVATED: {
    component_name: '',
    component_type: 'pwa',
    event: 'pwa_open',
    pagePWA:'true'
  },
}


export type TLanguageUpdate = TTrackEventData<{
  dialog_action: string;
}>;

export type TPartnerHubClick = TTrackEventData<{
  pageGroup: string;
  event_type: string;
}>;

export type TNotificationIconClick = TTrackEventData<{
  pageGroup: string;
  event_type: string;
  list_action: string;
}>


export type TNotificationListOnEngage = TTrackEventData<{
  list_action: string;
}>;

export type TNotificationListOnView = TTrackEventData<{
  list_action: string;
  list_countsTotal: number;
  list_countsFlag: boolean
}>;

export type TNotificationOnClose = TTrackEventData<{
  notification_action: string;
  notification_detail: string;
}>;


export type TBannerView = TTrackEventData<{
  banner_action: string;
}>;

export type TBannerSelect = TTrackEventData<{
  banner_action: string;
}>;

export type TBannerDismiss = TTrackEventData<{
  banner_action: string;
}>;

export type TBannerError = TTrackEventData<{
  banner_action: string;
  banner_errorType: string
}>;

export type TPWAActivated = TTrackEventData<{
  pagePWA: string;
}>;